import React from 'react';
import { Navigate } from 'react-router-dom';
import Spinner from '../Spinner';

const AdminRoute = ({ user, loading, children }) => {
  if (loading) return <Spinner message="Loading..." />;

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;